<template>
  <div class="d-block">
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex align-items-center mb-3" style="justify-content: space-between;">
          <h5 class="mb-0">Данные по запросу поставщику</h5>

          <b-button
            @click="updateShowItemData()"
            size="sm"
            variant="reload"
          >
            <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="isItemRefreshing ? 'spin' : ''"></b-icon>
          </b-button>
        </div>
      </div>
    </div>
    
    <b-overlay :show="isItemRefreshing" rounded="sm">
      <b-list-group>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <b>Тема письма:</b>
            </div>
            <div class="form-group col-md-9 mb-0">
              {{ editedItem.subject }}
            </div>
          </div>                    
        </b-list-group-item>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <b>Содержимое письма:</b>
            </div>
            <div class="form-group col-md-9 mb-0">
              <b-button
                v-b-toggle.collapse-letter-body
                size="sm"
                variant="outline-secondary"
              >
                {{ isLetterBodyCollapsed ? 'Свернуть письмо':'Развернуть письмо' }}
              </b-button>
              <b-collapse id="collapse-letter-body" v-model="isLetterBodyCollapsed" class="mt-2">
                <span class="letter-body" v-html="editedItem.body"></span>
                <span class="letter-body" v-html="editedItem.creator.body_sign"></span>
              </b-collapse>
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <template v-if="editedItem.sent_emails_count > 0">
                <b>Отправлено от:</b>
              </template>
              <template v-else>
                <b>Будет отправлено от:</b>
              </template>
            </div>
            <div class="form-group col-md-9 mb-0">
              <template v-if="editedItem.creator">
                {{ editedItem.creator.name }}
              </template>
              <template v-else>
                Отправитель не указан
              </template>

              <template v-if="editedItem.sent_emails_count === 0">
                <div><small><em>Отправителя можно изменить только если создать запрос заново!</em></small></div>
              </template>
            </div>
          </div>      
        </b-list-group-item>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <b>Вложения письма:</b>
            </div>
            <div class="form-group col-md-9 mb-0">
              <template v-if="editedItem.attachments.length > 0">
                <template v-for="(item, index) in editedItem.attachments">
                  <a :href="`${hfs}uploads/${item}`" target="_blank">Файл {{ index + 1 }}</a>
                  <template v-if="editedItem.attachments[index + 1]">
                    | 
                  </template>
                </template>
              </template>
              <template v-else>
                Вложения отсутствуют.
              </template>
            </div>
          </div>      
        </b-list-group-item>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <b>Компаний отобрано:</b>
            </div>
            <div class="form-group col-md-1 mb-0">
              <template v-if="editedItem.search_parameters &&
                              editedItem.search_parameters.selectedSuppliers">
                {{ editedItem.search_parameters.selectedSuppliers.length }}
              </template>
              <template v-else>0</template>
            </div>
            <div class="form-group col-md-3 mb-0">
              <b>Контактов для рассылки:</b>
            </div>
            <div class="form-group col-md-1 mb-0">
              <template v-if="editedItem.search_parameters &&
                              editedItem.search_parameters.selectedSuppliersEmployee">
                {{ editedItem.search_parameters.selectedSuppliersEmployee.length }}
              </template>
              <template v-else>0</template>
            </div>
          </div>    
        </b-list-group-item>
        <b-list-group-item v-if="emailsTotal > 0">
          <div class="sending-progress">
            <div class="sending-progress__title">
              Отправлено <strong>{{ sentCount }}</strong> из <strong>{{ emailsTotal }}</strong>
            </div>
            <b-progress :max="emailsTotal" height="1.1rem" class="mb-2" show-value>
              <b-progress-bar :value="sentCount" variant="success" :label="sentCount ? String(sentCount) : ''" />
              <b-progress-bar :value="queuedCount + retryingCount" variant="info" :label="(queuedCount + retryingCount) ? String(queuedCount + retryingCount) : ''" />
              <b-progress-bar :value="failedCount" variant="danger" :label="failedCount ? String(failedCount) : ''" />
            </b-progress>
            <div class="sending-progress__details text-muted">
              В очереди: {{ queuedCount }},
              повторные попытки: {{ retryingCount }},
              не отправлено: {{ failedCount }}
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="form-row">
            <div class="form-group col-md-3 mb-0">
              <b>Операции:</b>
            </div>
            <div class="form-group col-md-9 mb-0">
              <template v-if="editedItem.search_parameters && 
                              editedItem.search_parameters.selectedSuppliersEmployee && 
                              editedItem.search_parameters.selectedSuppliersEmployee.length > 0">
                <b-button
                  v-if="editedItem.sent_errors_count == 0"
                  @click="questionAboutSending()"
                  :disabled="sendInProgress ||
                              (!emailTrackingInfoLoaded 
                              && emailTrackingItemsTotal > 0) ||
                              (emailTrackingItemsTotal == editedItem.search_parameters.selectedSuppliersEmployee.length)"
                  size="sm"
                  variant="reload"
                  id="send-messages-to-suppliers"
                >
                  <template v-if="emailTrackingItemsTotal == 0 &&
                                  emailTrackingItemsTotal < editedItem.search_parameters.selectedSuppliersEmployee.length">
                    Отправить письма поставщикам
                  </template>
                  <template v-else>
                    Письма отправлены
                  </template>
                </b-button>

                <template v-if="editedItem.sent_errors_count > 0">
                  <b-button
                    @click="questionAboutReSending()"
                    :disabled="sendInProgress || !emailTrackingInfoLoaded"
                    size="sm"
                    variant="secondary"
                    id="send-messages-to-suppliers"
                  >
                      Отправить повторно ошибочные
                  </b-button>                  
                </template>
              </template>
              <template v-else>
                Необходимо отобрать поставщиков с контактами! Вернитесь к редактированию запроса и попробуйте собрать больше поставщиков в выборку для отправки.
              </template>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>  
    </b-overlay>
    
    <div class="mt-4">
      <EmailTrackingFinder
        :additionalGetParameter="`&order_supplier_request_id=${editedItem.id}`"
        :key="componentRefreshKey"
        @onLoad="onLoad"
      ></EmailTrackingFinder>      
    </div>
  </div>
</template>

<script>
  import { API_ORDER_SUPPLIER, HOST_FOR_STORAGE } from "@/constants";
  import EmailTrackingFinder from "@/components/emailTracking/EmailTrackingFinder";

  export default {
    props: {
      editedItem: {
        type: Object,
        required: true,
      },
      isItemRefreshing: {
        type: Boolean,
        default: false
      }
    },

    components: {
      EmailTrackingFinder
    },

    data() {
      return {
        componentRefreshKey: 1,
        emailTrackingInfoLoaded: false,
        emailTrackingItemsTotal: 0,
        sendInProgress: false,
        hfs: HOST_FOR_STORAGE,
        isLetterBodyCollapsed: false,
        progressTimer: null
      };
    },

    computed: {
      emailsTotal() {
        return Number(this.editedItem.emails_count || 0);
      },
      sentCount() {
        return Number(this.editedItem.sent_emails_count || 0);
      },
      retryingCount() {
        return Number(this.editedItem.retrying_emails_count || 0);
      },
      failedCount() {
        return Number(this.editedItem.sent_errors_count || 0);
      },
      queuedCount() {
        return Math.max(0, this.emailsTotal - this.sentCount - this.retryingCount - this.failedCount);
      },
      isSendingInProgress() {
        return this.emailsTotal > 0 && (this.queuedCount > 0 || this.retryingCount > 0);
      },
      progressSignature() {
        return [this.emailsTotal, this.sentCount, this.retryingCount, this.failedCount].join('-');
      },
      formattedBody() {
        return this.editedItem.body.replace(/\r\n/g, '<br>');
      }
    },

    watch: {
      progressSignature(newValue, oldValue) {
        if (this.progressTimer && newValue !== oldValue) {
          this.componentRefreshKey++;
        }
      },
      isSendingInProgress: {
        immediate: true,
        handler(value) {
          if (value) {
            this.startProgressPolling();
          } else {
            this.stopProgressPolling();
          }
        }
      }
    },

    beforeDestroy() {
      this.stopProgressPolling();
    },

    methods: {
      onLoad(total) {
        this.emailTrackingInfoLoaded = true;
        this.emailTrackingItemsTotal = total;
      },
      startProgressPolling() {
        if (this.progressTimer) {
          return;
        }
        this.progressTimer = setInterval(() => {
          if (!this.isSendingInProgress) {
            this.stopProgressPolling();
            return;
          }
          this.$emit('updateShowItemData', true);
        }, 10000);
      },
      stopProgressPolling() {
        if (this.progressTimer) {
          clearInterval(this.progressTimer);
          this.progressTimer = null;
        }
      },
      questionAboutSending() {
        this.$swal.fire({
          title: "Вы уверены что всё готово к отправке?",
          text: "Это действие нельзя будет отменить!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0D6247",
          cancelButtonColor: "#676868",
          confirmButtonText: "Да, я уверен!",
          cancelButtonText: "Отменить",
        }).then((result) => {
          if (result.isConfirmed) {
            this.sendEmailsToSuppliers();
          }
        });        
      },
      sendEmailsToSuppliers() {
        if (this.sendInProgress) {
          return;
        }
        this.sendInProgress = true;
        this.emailTrackingInfoLoaded = false;

        api.call('post', `${API_ORDER_SUPPLIER}/${this.editedItem.id}/send`)
          .then((response) => {
            this.emailTrackingInfoLoaded = true;
            this.componentRefreshKey++;
            this.updateShowItemData();
            this.startProgressPolling();

            this.$bvToast.toast('Письма на отправку поставлены в очередь. Следите за обновлениями на этой странице.', {
              title: 'Запросы успешно созданы',
              variant: 'success',
              solid: true,
            });
          })
          .catch((error) => {
            console.error(error);
            this.emailTrackingInfoLoaded = true;
          })
          .finally(() => {
            this.sendInProgress = false;
          });
      },
      questionAboutReSending() {
        this.$swal.fire({
          title: "Вы уверены что исправлены все ошибки?",
          text: "Если вы проверили все треугольнички напротив ошибочных записей, то можно отправить на переотправку!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0D6247",
          cancelButtonColor: "#676868",
          confirmButtonText: "Да, я уверен!",
          cancelButtonText: "Отменить",
        }).then((result) => {
          if (result.isConfirmed) {
            this.reSendEmailsToSuppliers();
          }
        });        
      },
      reSendEmailsToSuppliers() {
        if (this.sendInProgress) {
          return;
        }
        this.sendInProgress = true;
        this.emailTrackingInfoLoaded = false;

        api.call('post', `${API_ORDER_SUPPLIER}/${this.editedItem.id}/resend`)
          .then((response) => {
            this.emailTrackingInfoLoaded = true;
            this.componentRefreshKey++;
            this.updateShowItemData();
            this.startProgressPolling();

            this.$bvToast.toast('Письма на повторную отправку поставлены в очередь. Следите за обновлениями на этой странице.', {
              title: 'Запросы успешно отправлены',
              variant: 'success',
              solid: true,
            });
          })
          .catch((error) => {
            console.error(error);
            this.emailTrackingInfoLoaded = true;
          })
          .finally(() => {
            this.sendInProgress = false;
          });
      },      
      updateShowItemData() {
        this.$emit('updateShowItemData');
      }
    },
  };
</script>

<style lang="scss" scoped>
.sending-progress__title {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}
.sending-progress__details {
  font-size: 0.9rem;
}
</style>
